import type { Extensions } from '../framework/microAppTypes'
import propFallbackExts from './propFallbackExts'
import favoriteNavExtension from './favoriteNavExtension'
import featureFlagProviderExts from './featureFlagProviderExts'
import serviceUrlProviderExts from './serviceUrlProviderExts'
import tsgAccessAvailExts from './tsgAccessAvailExts'

export default [
  propFallbackExts,
  favoriteNavExtension,
  featureFlagProviderExts,
  serviceUrlProviderExts,
  tsgAccessAvailExts,
] as Extensions
